let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2T8K7")).then(() => parcelRequire('gaE5c'));